import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Card } from 'react-bootstrap'
import { t } from '../../localization/localization'
import sdg_icons from '../../data/sdg_icons'
import Rosette from '../../components/rosette'
import axios from 'axios'

const colors = [
  '#E5243B',
  '#DDA83A',
  '#4C9F38',
  '#C5192D',
  '#FF3A21',
  '#26BDE2',
  '#FCC30B',
  '#A21942',
  '#FD6925',
  '#DD1367',
  '#FD9D24',
  '#BF8B2E',
  '#3F7E44',
  '#0A97D9',
  '#56C02B',
  '#00689D',
  '#19486A',
]

const SdgWall = () => {
  const [handleSdgData, setHandleSdgData] = useState()
  const [errorSdgData, setErrorSdgData] = useState()
  const urlSearchParams = new URLSearchParams(window.location.search)
  const locale = urlSearchParams.get('locale') ?? 'tr'

  useEffect(() => {
    const firstId = window.location.pathname.split('/')[3]
    const secondId = window.location.pathname.split('/')[4]
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/publication/sdg`, {
        params: {
          handle: `${firstId}/${secondId}`,
        },
      })
      .then(
        (res) => {
          setHandleSdgData(res?.data)
        },
        (reason) => setErrorSdgData(reason)
      )
  }, [])

  return handleSdgData ? (
    <Container className=" overflow-hidden">
      <h4 className="text-capitalize mt-4">
        {t(locale, '/rs/rosettes/sdg-rosettes')}
      </h4>
      <Row className="wall vh-100 overflow-auto ">
        <SdgRosettes sdgReport={handleSdgData} />
      </Row>
    </Container>
  ) : errorSdgData ? (
    <Col>
      <Card className="flex" body>
        {errorSdgData?.response.data.status === 400 ? (
          t(locale, '/rs/rosettes/no-sdg-rosettes')
        ) : (
          <div className="text-danger p-2 flex-fill alert-danger">
            {errorSdgData?.response.data.error}
          </div>
        )}
      </Card>
    </Col>
  ) : (
    <div>{t(locale,"/common/Loading")}...</div>
  )
}

export default SdgWall

const SdgRosettes = ({ sdgReport }) => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const locale = urlSearchParams.get('locale') ?? 'tr'
  let countOfRosettes = 0

  return (
    <>
      <Col className="mb-5">
        <Row className="mb-4">
          {sdgReport &&
            sdgReport.map((entry, idx) => {
              if (entry.count > 0) {
                countOfRosettes += 1
                return (
                  <Col className="col-8 col-sm-6 col-md-4 col-lg-3 ">
                    <Rosette
                      color={colors[idx]}
                      icon={sdg_icons[idx]}
                      text={t(locale, `/rosettes/${entry.name}`)}
                      idx={idx}
                    />
                  </Col>
                )
              }
            })}
          {countOfRosettes === 0 && (
            <Col>
              <Card body>{t(locale, '/rs/rosettes/no-sdg-rosettes')}</Card>
            </Col>
          )}
        </Row>
      </Col>
    </>
  )
}
